// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.games-main {
    width: 100%;
}

.basic-games {
    padding-top: 75px;
    padding-bottom: 0%;
    margin-left: 5%;
    margin-right: 5%;
}

.games-heading-div {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 50px;
}

.games-heading-text-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.games-heading-text {
    font-size: 56px;
    font-weight: 400;
    line-height: 1.1;
    margin-bottom: 20px;
}

.games-header-detail-text {
    font-size: 20px;
    line-height: 1.5;
    margin-top: 0px;
}

/* Games Section */
.games-section {
    padding: 48px 0;
}

.games-container {
    margin-left: 5%;
    margin-right: 5%;
    padding-bottom: 20px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
}

/* Game Card */
.game-card {
    border-radius: 8px;
    overflow: hidden;
    transition: box-shadow 0.3s ease, transform 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

.game-card:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    transform: translateY(-4px);
}

/* Game Cover */
.game-cover-container {
    position: relative;
    aspect-ratio: 616 / 353;
    overflow: hidden;
}

.game-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.game-card:hover .game-cover {
    transform: scale(1.05);
}

.game-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0);
    transition: background 0.3s ease;
}

.game-card:hover .game-overlay {
    background: rgba(0, 0, 0, 0.2);
}

/* Game Info */
.game-info {
    padding: 12px;
    flex: 1 1;
}

.game-title {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

/* Responsive Design */
@media (min-width: 640px) {
    .games-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 768px) {
    .games-container {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (min-width: 1024px) {
    .games-container {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 768px) {


    .games-heading-div {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .games-heading-text {
        font-size: 40px;
    }

    .games-header-detail-text {
        font-size: 18px;
    }

    .games-container {
        grid-template-columns: 1fr;
        padding: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/games/Games.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qDAAqD;IACrD,wCAAwC;IACxC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,cAAc;AACd;IACI,aAAa;IACb,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;;;IAGI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;QAC1B,aAAa;IACjB;AACJ","sourcesContent":[".games-main {\n    width: 100%;\n}\n\n.basic-games {\n    padding-top: 75px;\n    padding-bottom: 0%;\n    margin-left: 5%;\n    margin-right: 5%;\n}\n\n.games-heading-div {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\n    gap: 50px;\n}\n\n.games-heading-text-div {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.games-heading-text {\n    font-size: 56px;\n    font-weight: 400;\n    line-height: 1.1;\n    margin-bottom: 20px;\n}\n\n.games-header-detail-text {\n    font-size: 20px;\n    line-height: 1.5;\n    margin-top: 0px;\n}\n\n/* Games Section */\n.games-section {\n    padding: 48px 0;\n}\n\n.games-container {\n    margin-left: 5%;\n    margin-right: 5%;\n    padding-bottom: 20px;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n}\n\n/* Game Card */\n.game-card {\n    border-radius: 8px;\n    overflow: hidden;\n    transition: box-shadow 0.3s ease, transform 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n}\n\n.game-card:hover {\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);\n    transform: translateY(-4px);\n}\n\n/* Game Cover */\n.game-cover-container {\n    position: relative;\n    aspect-ratio: 616 / 353;\n    overflow: hidden;\n}\n\n.game-cover {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.3s ease;\n}\n\n.game-card:hover .game-cover {\n    transform: scale(1.05);\n}\n\n.game-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0);\n    transition: background 0.3s ease;\n}\n\n.game-card:hover .game-overlay {\n    background: rgba(0, 0, 0, 0.2);\n}\n\n/* Game Info */\n.game-info {\n    padding: 12px;\n    flex: 1;\n}\n\n.game-title {\n    font-size: 14px;\n    font-weight: 600;\n    margin: 0;\n    line-height: 1.4;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n\n/* Responsive Design */\n@media (min-width: 640px) {\n    .games-container {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (min-width: 768px) {\n    .games-container {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media (min-width: 1024px) {\n    .games-container {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n\n\n    .games-heading-div {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    .games-heading-text {\n        font-size: 40px;\n    }\n\n    .games-header-detail-text {\n        font-size: 18px;\n    }\n\n    .games-container {\n        grid-template-columns: 1fr;\n        padding: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
